import { Box, Typography } from '@mui/material';
import { formatCompactNumber } from '../../../../../utils';
import { Heading2, Heading3 } from '../../../../../components/Heading';
import ChartSection from './ChartSection';

const roundToOneDecimal = (value) => {
  const num = Number(value) || 0;
  return Math.round(num * 10) / 10;
};

const TabDataContent = ({
                            title,
                            subTitle,
                            iconImage,
                            photo,
                            gender,
                            details
                        }) => {
    // Null-safe destructure for nested details object
    const innerDetails = details?.details ?? {};

    const data = [
        {
            title: 'Current One Rep Max (Lbs.)',
            value: formatCompactNumber(roundToOneDecimal(innerDetails.current_orm), 1),
        },
        {
            title: 'Best One Rep Max (Lbs.)',
            value: formatCompactNumber(roundToOneDecimal(innerDetails.max_orm), 1),
        },
        {
            title: 'Sets | Reps',
            value: `${formatCompactNumber(roundToOneDecimal(innerDetails.set_count), 1)} | ${formatCompactNumber(roundToOneDecimal(innerDetails.rep_count), 1)}`,
        },
        {
            title: 'Total Volume (Lbs.)',
            value: formatCompactNumber(roundToOneDecimal(innerDetails.total_volume), 1),
        },
    ];

    // Get image sources null-safely
    const iconSrc = iconImage ?? '';
    const photoSrc = gender === 'Female'
        ? photo?.female ?? ''
        : photo?.male ?? '';

    return (
        <Box display="flex" flexDirection={{ xs: 'column-reverse', tl: 'column', md: 'row' }}>
            {/* Profile and photo column */}
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <Box
                    display="flex"
                    alignItems="center"
                    sx={{
                        '& img': {
                            width: 88,
                            height: 88,
                            border: '1px solid #454545',
                            borderRadius: '50%',
                        },
                    }}
                >
                    <img src={iconSrc} alt={title} />
                    <Box ml={2}>
                        <Heading3>{title}</Heading3>
                        <Typography mt={1}>{subTitle}</Typography>
                    </Box>
                </Box>
                <Box
                    sx={{
                        mt: 5,
                        '& img': {
                            width: { md: 250, xl: 400 },
                            height: { md: 250, xl: 400 },
                            objectFit: 'cover',
                        },
                    }}
                >
                    <img src={photoSrc} alt="" />
                </Box>
            </Box>

            {/* Metrics column */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'row', md: 'column' },
                    justifyContent: 'space-between',
                    flexWrap: { xs: 'wrap', tl: 'unset' },
                    minWidth: 200,
                    ml: { xs: 0, md: 3 },
                    mt: { xs: 4, tl: 0 },
                    textAlign: 'center',
                    '& p': {
                        fontSize: 14,
                        marginBottom: 1,
                    },
                }}
            >
                {data.map((d, index) => (
                    <Box
                        key={index}
                        mb={4}
                        maxWidth={{ tl: 112, md: 'none' }}
                        width={{ xs: '50%', tl: 'auto' }}
                    >
                        <Typography sx={{ minHeight: { tl: 42, md: 'auto' } }}>{d.title}</Typography>
                        <Heading3 sx={{ fontSize: { xs: 16, md: 28 } }}>{d.value}</Heading3>
                    </Box>
                ))}
            </Box>

            {/* Chart section */}
            <Box ml={{ xs: 0, md: 3 }} mt={{ xs: 0, tl: 5, md: 0 }} flex={1}>
                {!!details?.chart ? (
                    <ChartSection title={subTitle} data={details.chart} />
                ) : (
                    <Box
                        display={{ xs: 'none', tl: 'flex' }}
                        justifyContent="center"
                        alignItems="center"
                        height="100%"
                    >
                        <Heading2>No Data</Heading2>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default TabDataContent;
